/**
 * @module
 * @category Data
 */

import { SocialAccount } from '@bomdisoft/components';

export const calendlyURL = 'https://calendly.com/adombang-munang-mbomndih/15min';

export const socialAccounts: SocialAccount = {
  email: 'support@pieleaff.com',
  facebook: 'https://www.facebook.com/pieleaff',
  instagram: 'https://www.instagram.com/pieleaf_org',
  linkedin: 'https://linkedin.com/company/pieleaf',
  mobile: '+372 5878 1144',
  x: 'https://x.com/bomdisoft',
};
